import React, { useContext } from "react";
import Input from "~/components/parts/Input";
import { Select, SelectItem } from "~/components/parts/Select";
import { SubscriptionContext } from "../../..";
import { ApplicationFormContext } from ".";

const Contact = () => {
  const { form = {} } = useContext(SubscriptionContext);
  const { values = {}, validity = {} } = form;

  const { handleInputChange } = useContext(ApplicationFormContext);

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
      <p className="col-span-1 m-0 -mb-3 text-sm font-semibold text-slate-700 lg:col-span-2 xl:col-span-3">
        Contact details
      </p>
      <Input
        label="Name"
        invalid={validity["contactName"] === false}
        name="contactName"
        onChange={handleInputChange}
        value={values.contactName}
      />
      <Input
        label="Email"
        invalid={validity["contactEmail"] === false}
        name="contactEmail"
        onChange={handleInputChange}
        value={values.contactEmail}
      />
      <div className="flex flex-col gap-1">
        <Select
          className={values.contactRole ? "" : "text-gray-400"}
          label="Role"
          invalid={validity["contactRole"] === false}
          name="contactRole"
          onChange={handleInputChange}
          value={values.contactRole}
        >
          <SelectItem value="" label="Please select" disabled />
          {[
            "Head of Department",
            "Second in Department",
            "Key Stage Coordinator",
            "Teacher",
            "Other",
          ].map((role) => (
            <SelectItem key={role} value={role} label={role} />
          ))}
        </Select>
        {values.contactRole === "Other" && (
          <Input
            invalid={validity["contactRoleCustom"] === false}
            name="contactRoleCustom"
            onChange={handleInputChange}
            placeholder="Please enter role"
            value={values.contactRoleCustom}
          />
        )}
      </div>
    </div>
  );
};

export default Contact;
